import { createReducer, on } from '@ngrx/store';

import { BetslipNotificationActions } from './betslip-notification.actions';
import { BetslipNotificationConverter } from './services/betslip-notification-converter';
import { defaultNotificationState } from './state';

export const notificationStateReducer = createReducer(
    defaultNotificationState,
    on(BetslipNotificationActions.setMessage, (state, action) => {
        return BetslipNotificationConverter.toState(action.payload);
    }),
    on(BetslipNotificationActions.clearMessage, (state) => {
        return defaultNotificationState;
    }),
);
